import { IGetOptions } from "@/constants/utils"
import { type ClassValue, clsx } from "clsx"
import { ReadonlyURLSearchParams } from "next/navigation"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
	return twMerge(clsx(inputs))
}

export const isMobile = ()=>{
 
	return /iPhone|iPad|iPod|Android/i.test(navigator.userAgent) || window.innerWidth < 480
};

export const getOptions = ({ options, searchParams }: IGetOptions) => {

	const utm_options: Record<string, string> = {}

	const required_keys = ["utm_source", "utm_medium", "utm_campaign"]

	searchParams.forEach((value, key) => {
		if (required_keys.includes(key)) utm_options[key] = value
	})

	return {
		Platform: isMobile() ? "M-Site" : "Web",
		...options,
		...utm_options,
	}
}

export const trackEvent = (
	event: string,
	options: Record<string, string | number | object>,
	searchParams: ReadonlyURLSearchParams,
	isPixelView = false,
) => {
	const params = getOptions({ options, searchParams })



	/* isPixelView && ReactPixel.pageView()
	ReactPixel.fbq("track", event, {
		event,
		...options,
		...params,
	}) */
}